import { getReadonlyListItemDate, getReadonlyListItemNumber } from '@interxfi/app-components/components/readonly-list/util';
import type { ReadonlyListItemRecord } from '@interxfi/design-system/components/list/readonly/item/readonly-list-item';
import type { J5StateV1StateMetadata } from '@interxfi/types/generated/api';

export function getJ5StateMetadataListItems(data: J5StateV1StateMetadata | undefined, prefix: string = 'metadata.') {
  return {
    createdAt: getReadonlyListItemDate(`${prefix}createdAt`, 'Created At', data?.createdAt, 'timestamp_iso_s'),
    updatedAt: getReadonlyListItemDate(`${prefix}updatedAt`, 'Updated At', data?.updatedAt, 'timestamp_iso_s'),
    lastSequence: getReadonlyListItemNumber(`${prefix}lastSequence`, 'Last Sequence', data?.lastSequence),
  } satisfies ReadonlyListItemRecord;
}
